import { Controller } from "@hotwired/stimulus"

// Простые табы для админских форм. Состояние храним в URL hash, чтобы
// после ошибок валидации остаться на том же табе.
//
// Дополнительно поддерживается «условный» таб: кнопка с
// data-tabs-feature="имя" видна только когда чекбокс с таким же
// data-tabs-feature-flag="имя" активен. Удобно скрывать пустые секции.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.applyFeatureFlags()
    this.element.querySelectorAll("[data-tabs-feature-flag]").forEach((cb) => {
      cb.addEventListener("change", () => this.applyFeatureFlags())
    })
    const serverDefault = this.element.dataset.tabsDefault
    const fromHash = window.location.hash?.replace(/^#tab-/, "")
    const initial =
      (this.isVisible(serverDefault) && serverDefault) ||
      (this.isVisible(fromHash) && fromHash) ||
      this.firstVisibleTabId()
    this.activate(initial)
  }

  switch(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.tabsId
    this.activate(id)
    history.replaceState(null, "", `#tab-${id}`)
  }

  activate(id) {
    this.tabTargets.forEach((t) => {
      t.classList.toggle("active", t.dataset.tabsId === id)
    })
    this.panelTargets.forEach((p) => {
      p.classList.toggle("active", p.dataset.tabsId === id)
    })
    this.element.querySelectorAll("[data-tabs-hide-on]").forEach((el) => {
      const hideOn = el.dataset.tabsHideOn.split(",").map((s) => s.trim())
      el.hidden = hideOn.includes(id)
    })
  }

  applyFeatureFlags() {
    const enabledFeatures = new Set(
      Array.from(this.element.querySelectorAll("[data-tabs-feature-flag]"))
        .filter((cb) => cb.checked)
        .map((cb) => cb.dataset.tabsFeatureFlag)
    )

    this.tabTargets.forEach((tab) => {
      const feature = tab.dataset.tabsFeature
      if (!feature) return
      const visible = enabledFeatures.has(feature)
      tab.hidden = !visible
      // Если активный таб скрылся — переключим на первый видимый.
      if (!visible && tab.classList.contains("active")) {
        this.activate(this.firstVisibleTabId())
      }
    })
  }

  isVisible(id) {
    const tab = this.tabTargets.find((t) => t.dataset.tabsId === id)
    return tab && !tab.hidden
  }

  firstVisibleTabId() {
    return this.tabTargets.find((t) => !t.hidden)?.dataset.tabsId
  }
}
